/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_A4Inputs */

const cs_template_aspect_a4 = /** @type {(inputs: Template_Aspect_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

const en_template_aspect_a4 = /** @type {(inputs: Template_Aspect_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

/**
* | output |
* | --- |
* | "A4" |
*
* @param {Template_Aspect_A4Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_a4 = /** @type {((inputs?: Template_Aspect_A4Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_A4Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_a4(inputs)
	return cs_template_aspect_a4(inputs)
});